<div class="dialog-shell">
    <div class="dialog-topbar">
        <button mat-icon-button mat-dialog-close class="button-close--outlined dialog-close" color="primary" aria-label="Chiudi">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-head">
        <div class="dialog-badge">
            <mat-icon>lock_open</mat-icon>
        </div>
        <h2 class="dialog-title">Recupera Password</h2>
        <p class="dialog-subtitle">Inserisci l'indirizzo e-mail del tuo account: ti invieremo un link per reimpostare la password.</p>
    </div>

    <div mat-dialog-content class="dialog-body">
        <form (ngSubmit)="onYesClick()" [formGroup]="formGroup" class="dialog-form">
            <mat-form-field class="fo-field">
                <mat-label>Email</mat-label>
                <input matInput type="email" formControlName="email" autocomplete="email" required />
                <mat-icon matSuffix>email</mat-icon>
                <mat-error class="error-message" *ngIf="formGroup.controls['email'].hasError('required')"
                    >La Mail è obbligatoria</mat-error
                >
                <mat-error class="error-message" *ngIf="formGroup.controls['email'].hasError('email')"
                    >La Mail non ha un formato valido.</mat-error
                >
            </mat-form-field>

            <button type="submit" class="fo-btn fo-btn--primary fo-btn--block dialog-submit" [disabled]="!formGroup.valid">
                INVIA RESET MAIL
            </button>

            <div class="dialog-links">
                <a (click)="resendMail()" *ngIf="formGroup.valid" class="dialog-link" tabindex="0">Invia nuovamente mail</a>
                <span *ngIf="!formGroup.valid" class="dialog-link is-disabled">Invia nuovamente mail</span>

                <p class="dialog-back">
                    <a (click)="goLogin()" class="dialog-link" tabindex="0">Torna al login</a>
                </p>
            </div>
        </form>
    </div>
</div>
